import { NotificationChannelTemplate } from './NotificationChannelTemplate';

export class EmailTemplate extends NotificationChannelTemplate {
  sendgrid_template_id?: string;
  bcc?: Array<string>;

  // App Helpers
  app_document_type_id?: number;
}
